import GetCompanyProfessionRequestModelBase from '../_generated/modelBases/get-company-profession-request-model-base';

export default class GetCompanyProfessionRequestModel extends GetCompanyProfessionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
